import { inject, injectable } from 'inversify';
import JsonRpcDispatcher from '@dealroadshow/json-rpc-dispatcher';
import TrackRequest from '../../TrackRequest';
import Tracker from '../../Tracker';
import SocketDispatcher from './SocketDispatcher';

@injectable()
class SocketSender implements Tracker {
  constructor(
    @inject(SocketDispatcher) protected readonly socketDispatcher: typeof JsonRpcDispatcher,
  ) {}

  async track({ eventName, payload }) {
    const request = new TrackRequest(eventName, payload);
    return this.socketDispatcher.call(request);
  }
}

export default SocketSender;
